// extracted by mini-css-extract-plugin
export default {"container":"IndicesFuture_container__cT2yz","tvcontainer":"IndicesFuture_tvcontainer__X81kv"};